function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Card, Empty, Pill } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import { Modal } from "../audiences/ui";
import { getQuote, createQuote, updateQuote, putLines, createComcol, requestPdf, sendQuote, approveQuote, extendQuote, duplicateQuote, voidQuote, convertQuote, getTiers, getQuoteSettings, DEFAULT_SETTINGS, listReps, searchCatalog, searchDealers, getConfigOptions, priceLine, totalsOf, tierPctFor, acceptanceLink, isAdminUser, currentUserEmail, idStr } from "../sales/sales-quotes-api";
import { QuotesGate, QuotesShell, QuoteStatus, Btn, Notice, money, money0, pctFmt, fmtDate, fmtDateTime, relTime, addDays, daysUntil, isLocked, errText, copyText, Crumb, normStatus } from "./common";

/*
 * Quote editor (SALES_QUOTES_ORDER_DESK.md §7, mockup B and C).
 *
 *   /Quotes/new   pick the dealer and the header, POST /v1/sales/quotes, then land on the draft
 *   /Quotes/:id   lines from the catalog with configurations from the rail, dealer-tier pricing per
 *                 line (the rule shown: tier or category override, adders, override with a reason),
 *                 validity, send sheet, PDF, acceptance link, COM/COL request on click, convert.
 *
 * Pricing is read from the server after every PUT /lines (resolved SKU, adders, net); between
 * saves the same rule runs locally (priceLine) so the numbers never go blank. A line whose
 * Cover reads COM/COL gets a "Create COM request" button; the Studio request is created only on
 * that click (DS 2026-10-05), never by picking the option.
 */
const COM_RE = /\bcom\b|\bcol\b|com\/col|customer'?s own/i;
const isCom = line => Object.entries(line.config || {}).some(([k, v]) => /cover|fabric|material/i.test(k) && COM_RE.test(String(v)));
const configText = cfg => Object.entries(cfg || {}).filter(([, v]) => v !== "" && v != null).map(([k, v]) => `${k}: ${v}`).join(" · ");
const comLabel = s => ({
  draft: "COM request: draft, no fabric yet",
  yardage_quote: "COM request: yardage quote",
  po_submitted: "COM request: PO submitted",
  rejected: "COM request: rejected"
})[String(s || "").toLowerCase()] || (s ? `COM request: ${String(s).replace(/_/g, " ")}` : "COM request");
const comTone = s => ({
  draft: "warning",
  yardage_quote: "info",
  po_submitted: "success",
  rejected: "danger"
})[String(s || "").toLowerCase()] || "neutral";
const availLabel = a => !a ? "" : typeof a === "string" ? a : a.label || a.status || "";
const availTone = a => {
  const s = String(availLabel(a)).toLowerCase();
  if (/in stock|available|ships/.test(s)) return "success";
  if (/made to order|backorder|weeks|lead/.test(s)) return "neutral";
  if (/discontinued|unavailable|out of stock/.test(s)) return "danger";
  return "neutral";
};
class QuoteEditorView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "pickDealer", d => {
      const hdr = {
        ...this.state.hdr
      };
      hdr.contact = {
        name: hdr.contact.name,
        email: hdr.contact.email || d.email || "",
        phone: hdr.contact.phone || d.phone || ""
      };
      hdr.repCode = hdr.repCode || d.assignedRepId || "";
      hdr.shipTo = d.shipTo || null;
      this.setState({
        dealer: d,
        hdr,
        dealerRows: null,
        dealerQ: ""
      });
    });
    _defineProperty(this, "create", async () => {
      const {
        dealer,
        hdr
      } = this.state;
      if (!dealer) {
        this.setState({
          notice: {
            tone: "warning",
            text: "Pick the dealer first."
          }
        });
        return;
      }
      this.setState({
        busy: true,
        notice: null
      });
      try {
        const q = await createQuote({
          customerId: dealer.id,
          contact: hdr.contact.email || hdr.contact.name ? hdr.contact : undefined,
          title: hdr.title || undefined,
          repCode: hdr.repCode || undefined,
          validDays: Math.max(1, Math.round((new Date(hdr.validUntil + "T00:00:00") - new Date().setHours(0, 0, 0, 0)) / 86400000)) || undefined,
          shipTo: hdr.shipTo || undefined,
          lines: []
        });
        if (!this._alive) return;
        if (q === null) {
          this.setState({
            busy: false,
            notice: {
              tone: "info",
              text: "Quotes are not available yet for this workspace: the desk's backend is being enabled. Nothing was saved."
            }
          });
          return;
        }
        this.props.history.replace(`/Quotes/${encodeURIComponent(q.id)}`);
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The quote could not be created.")
          }
        });
      }
    });
    _defineProperty(this, "addFromCatalog", p => {
      const line = {
        id: "",
        productId: p.productId,
        sku: p.sku,
        title: p.title,
        imageUrl: p.imageUrl,
        config: {},
        configText: "",
        comOrderId: "",
        comStatus: "",
        quantity: 1,
        listPrice: p.listPrice,
        optionAdders: 0,
        discountPct: 0,
        discountRule: "",
        netPrice: null,
        overridePrice: null,
        overrideReason: "",
        overrideBy: "",
        extended: null,
        availability: p.availability ? {
          label: p.availability
        } : null,
        leadTimeDays: null,
        note: "",
        category: p.category,
        _serverPriced: false
      };
      this.setState(s => ({
        lines: s.lines.concat([line]),
        dirty: true,
        modal: null,
        catQ: "",
        catRows: null
      }));
    });
    _defineProperty(this, "applyConfigure", () => {
      const {
        modalIdx,
        cfgDraft,
        cfgSets,
        cfgNote
      } = this.state;
      const cfg = Object.fromEntries(Object.entries(cfgDraft).filter(([k, v]) => k && v !== "" && v != null));
      let adders = 0;
      let sku = "";
      (cfgSets || []).forEach(set => {
        const o = (set.options || []).find(x => x.value === cfg[set.name] || x.label === cfg[set.name]);
        if (o) {
          adders += Number(o.adder) || 0;
          if (o.sku) sku = o.sku;
        }
      });
      const line = this.state.lines[modalIdx];
      this.setLine(modalIdx, {
        config: cfg,
        configText: configText(cfg),
        optionAdders: adders,
        sku: sku || line.sku,
        note: cfgNote
      });
      this.setState({
        modal: null,
        modalIdx: -1
      });
    });
    _defineProperty(this, "applyOverride", () => {
      const {
        modalIdx,
        ovPrice,
        ovReason
      } = this.state;
      if (!ovReason.trim()) {
        this.setState({
          notice: {
            tone: "warning",
            text: "An override needs a reason."
          }
        });
        return;
      }
      this.setLine(modalIdx, {
        overridePrice: Number(ovPrice) || 0,
        overrideReason: ovReason.trim(),
        overrideBy: currentUserEmail()
      });
      this.setState({
        modal: null,
        modalIdx: -1,
        notice: null
      });
    });
    // ---- save / actions ------------------------------------------------------------
    _defineProperty(this, "save", async thenFn => {
      const {
        quote,
        hdr,
        lines
      } = this.state;
      if (!quote) return null;
      this.setState({
        busy: true,
        notice: null
      });
      try {
        let q = await updateQuote(quote.id, {
          title: hdr.title,
          contact: hdr.contact,
          repCode: hdr.repCode || null,
          validUntil: hdr.validUntil,
          terms: hdr.terms,
          notes: hdr.notes,
          shipTo: hdr.shipTo,
          freight: hdr.freight
        });
        let res;
        try {
          res = await putLines(quote.id, lines);
        } catch (e) {
          // A bad line fails the whole PUT: 422 { error, code, position, productId }. Show it on that row, keep the local edits.
          const d = e && e.data || {};
          const pos = Number(d.position);
          if (e && e.status === 422 && Number.isFinite(pos) && pos >= 1) {
            if (this._alive) this.setState({
              busy: false,
              quote: q || quote,
              lineError: {
                index: pos - 1,
                productId: d.productId ? String(d.productId) : "",
                text: errText(e, d.error || "This line was refused.")
              },
              notice: {
                tone: "warning",
                text: `Line ${pos} was refused; the header was saved, the lines were not.`
              }
            });
            return null;
          }
          throw e;
        }
        const merged = {
          ...(q || quote),
          lines: res.lines
        };
        if (res.totals) {
          const t = res.totals;
          ["subtotalList", "discountTotal", "subtotalNet"].forEach(k => {
            if (t[k] != null) merged[k] = Number(t[k]);
          });
        }
        if (!this._alive) return merged;
        this.setState({
          quote: merged,
          lines: res.lines.map(l => ({
            ...l,
            _serverPriced: true
          })),
          busy: false,
          dirty: false,
          lineError: null,
          notice: {
            tone: "info",
            text: "Draft saved."
          }
        });
        if (thenFn) thenFn(merged);
        return merged;
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The draft could not be saved.")
          }
        });
        return null;
      }
    });
    _defineProperty(this, "comRequest", async i => {
      const line = this.state.lines[i];
      if (!line.id) {
        this.setState({
          notice: {
            tone: "warning",
            text: "Save the draft first so the line exists, then create the COM request."
          }
        });
        return;
      }
      this.setState({
        comBusy: line.id
      });
      try {
        const r = await createComcol(this.state.quote.id, line.id);
        if (this._alive) {
          this.setLine(i, {
            comOrderId: r.comOrderId,
            comStatus: r.status
          });
          this.setState({
            comBusy: "",
            dirty: this.state.dirty
          });
        }
      } catch (e) {
        if (this._alive) this.setState({
          comBusy: "",
          notice: {
            tone: "danger",
            text: errText(e, "The COM request could not be created.")
          }
        });
      }
    });
    _defineProperty(this, "previewPdf", async () => {
      const {
        quote
      } = this.state;
      if (!quote) return;
      if (this.state.dirty) {
        const saved = await this.save();
        if (!saved) return;
      }
      this.setState({
        pdfBusy: true,
        notice: null
      });
      try {
        const ack = await requestPdf(quote.id);
        const note = ack && typeof ack === "object" && ack.note ? String(ack.note) : "";
        if (note && this._alive) this.setState({
          notice: {
            tone: "info",
            text: note
          }
        });
        const before = quote.pdfUrl;
        let tries = 0;
        const poll = async () => {
          if (!this._alive) return;
          tries += 1;
          const q = await getQuote(quote.id).catch(() => null);
          if (q && q.pdfUrl && (q.pdfUrl !== before || tries > 1)) {
            this.setState({
              quote: {
                ...this.state.quote,
                pdfUrl: q.pdfUrl
              },
              pdfBusy: false
            });
            window.open(q.pdfUrl, "_blank", "noopener");
            return;
          }
          if (tries >= 20) {
            this.setState({
              pdfBusy: false,
              notice: {
                tone: "info",
                text: "The PDF is still rendering. It appears in the side panel when it is ready."
              }
            });
            return;
          }
          this._pdfTimer = setTimeout(poll, 3000);
        };
        this._pdfTimer = setTimeout(poll, 2500);
      } catch (e) {
        if (this._alive) this.setState({
          pdfBusy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The PDF could not be requested.")
          }
        });
      }
    });
    _defineProperty(this, "openSend", () => {
      const {
        quote,
        hdr
      } = this.state;
      this.setState({
        modal: "send",
        sendTo: hdr.contact.email || "",
        sendCc: "",
        sendMsg: "",
        sendValid: hdr.validUntil || quote.validUntil || addDays((this.state.settings || DEFAULT_SETTINGS).validDays),
        sendErr: "",
        sentLink: ""
      });
    });
    _defineProperty(this, "send", async () => {
      const {
        quote,
        sendTo,
        sendCc,
        sendMsg,
        sendValid,
        hdr
      } = this.state;
      if (!sendTo.trim()) {
        this.setState({
          sendErr: "Add the dealer contact's email."
        });
        return;
      }
      this.setState({
        busy: true,
        sendErr: ""
      });
      try {
        if (sendTo.trim() !== (hdr.contact.email || "")) this.setState({
          hdr: {
            ...hdr,
            contact: {
              ...hdr.contact,
              email: sendTo.trim()
            }
          }
        });
        const saved = await new Promise(resolve => setTimeout(() => resolve(this.save()), 0));
        if (!saved) {
          this.setState({
            busy: false
          });
          return;
        }
        const r = await sendQuote(quote.id, {
          message: sendMsg || undefined,
          validUntil: sendValid || undefined,
          cc: sendCc.split(/[,\s;]+/).map(x => x.trim()).filter(Boolean)
        });
        if (!this._alive) return;
        const q = r.quote || saved;
        const emailNote = r.email && r.email.error ? {
          tone: "warning",
          text: `The quote is sent (v${q.version}) and the link works, but the email did not go: ${r.email.error}. Copy the link to the dealer, or resend once the address is fixed.`
        } : {
          tone: "info",
          text: `Sent to ${sendTo.trim()} as v${q.version}.${r.pdfJobId ? " The PDF is rendering." : ""}`
        };
        this.setState({
          quote: {
            ...q,
            link: r.link || q.link
          },
          lines: (q.lines || []).map(l => ({
            ...l,
            _serverPriced: true
          })),
          hdr: this.hdrFrom(q),
          busy: false,
          sentLink: r.link || acceptanceLink(q),
          sendErr: r.email && r.email.error ? `Email not delivered: ${r.email.error}` : "",
          notice: emailNote
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          sendErr: errText(e, "The quote could not be sent.")
        });
      }
    });
    _defineProperty(this, "approve", async () => {
      try {
        this.setState({
          busy: true
        });
        const q = await approveQuote(this.state.quote.id);
        if (this._alive) this.setState({
          quote: q || {
            ...this.state.quote,
            status: "draft"
          },
          busy: false,
          notice: {
            tone: "info",
            text: "Approved. The quote can be sent."
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "Approval failed.")
          }
        });
      }
    });
    _defineProperty(this, "extend", async () => {
      const {
        quote,
        extendDate
      } = this.state;
      if (!extendDate) return;
      try {
        this.setState({
          busy: true
        });
        const q = await extendQuote(quote.id, extendDate);
        if (this._alive) this.setState({
          quote: q || {
            ...quote,
            validUntil: extendDate,
            status: "sent"
          },
          hdr: {
            ...this.state.hdr,
            validUntil: extendDate
          },
          modal: null,
          busy: false,
          notice: {
            tone: "info",
            text: `Validity extended to ${fmtDate(extendDate)} and the dealer was sent the refreshed link.`
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The extension failed.")
          }
        });
      }
    });
    _defineProperty(this, "duplicate", async () => {
      try {
        this.setState({
          busy: true
        });
        const q = await duplicateQuote(this.state.quote.id);
        if (!this._alive) return;
        if (q && q.id) this.props.history.push(`/Quotes/${encodeURIComponent(q.id)}`);else this.setState({
          busy: false
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The duplicate could not be created.")
          }
        });
      }
    });
    _defineProperty(this, "doVoid", async () => {
      const {
        quote,
        voidReason
      } = this.state;
      if (!voidReason.trim()) return;
      try {
        this.setState({
          busy: true
        });
        await voidQuote(quote.id, voidReason.trim());
        if (this._alive) this.setState({
          quote: {
            ...quote,
            status: "void"
          },
          modal: null,
          busy: false,
          notice: {
            tone: "info",
            text: "Quote voided."
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The quote could not be voided.")
          }
        });
      }
    });
    _defineProperty(this, "convert", async () => {
      const {
        quote,
        poNumber,
        requestedDate
      } = this.state;
      try {
        this.setState({
          busy: true
        });
        const or = await convertQuote(quote.id, {
          poNumber: poNumber || undefined,
          requestedDate: requestedDate || undefined
        });
        if (!this._alive) return;
        if (or && or.id) this.props.history.push(`/Quotes/orders/${encodeURIComponent(or.id)}`);else this.setState({
          busy: false,
          modal: null,
          quote: {
            ...quote,
            status: "converted"
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The order request could not be created.")
          }
        });
      }
    });
    _defineProperty(this, "switchTier", async () => {
      const {
        quote,
        tierPick
      } = this.state;
      if (!tierPick) return;
      try {
        this.setState({
          busy: true
        });
        const q = await updateQuote(quote.id, {
          tier: tierPick
        });
        if (this._alive) this.setState({
          quote: q || {
            ...quote,
            priceTier: tierPick
          },
          lines: this.state.lines.map(l => ({
            ...l,
            _serverPriced: false
          })),
          modal: null,
          busy: false,
          dirty: true,
          notice: {
            tone: "info",
            text: "Tier switched for this quote. Save the draft to reprice the lines."
          }
        });
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          notice: {
            tone: "danger",
            text: errText(e, "The tier could not be switched.")
          }
        });
      }
    });
    _defineProperty(this, "copyLink", () => {
      const link = this.state.quote.link || acceptanceLink(this.state.quote);
      copyText(link).then(ok => {
        if (this._alive) {
          this.setState({
            copied: ok
          });
          setTimeout(() => this._alive && this.setState({
            copied: false
          }), 2000);
        }
      });
    });
    const sp = new URLSearchParams(props.location && props.location.search || "");
    this.state = {
      quote: undefined,
      lines: [],
      tiers: undefined,
      settings: null,
      reps: [],
      error: false,
      notice: null,
      busy: false,
      dirty: false,
      // new mode
      dealerQ: "",
      dealerRows: null,
      dealer: null,
      presetCustomerId: sp.get("customerId") || "",
      hdr: {
        title: "",
        repCode: "",
        contact: {
          name: "",
          email: "",
          phone: ""
        },
        validUntil: "",
        terms: "",
        notes: "",
        shipTo: null,
        freight: {
          mode: "quote",
          amount: null
        }
      },
      modal: null,
      // catalog | configure | override | send | convert | extend | void | tier
      modalIdx: -1,
      catQ: "",
      catRows: null,
      cfgSets: undefined,
      cfgDraft: {},
      cfgNote: "",
      ovPrice: "",
      ovReason: "",
      sendTo: "",
      sendCc: "",
      sendMsg: "",
      sendValid: "",
      sendErr: "",
      sentLink: "",
      poNumber: "",
      requestedDate: "",
      voidReason: "",
      extendDate: "",
      tierPick: "",
      pdfBusy: false,
      copied: false,
      comBusy: "",
      lineError: null
    };
    this._alive = true;
  }
  id() {
    const id = this.props.params && this.props.params.id;
    return id && id !== "new" ? decodeURIComponent(id) : "";
  }
  isNew() {
    return !this.id();
  }
  componentDidMount() {
    getTiers().then(t => this._alive && this.setState({
      tiers: t
    })).catch(() => this._alive && this.setState({
      tiers: null
    }));
    getQuoteSettings().then(s => this._alive && this.setState({
      settings: s || {
        ...DEFAULT_SETTINGS
      },
      hdr: this.isNew() ? {
        ...this.state.hdr,
        validUntil: addDays((s || DEFAULT_SETTINGS).validDays),
        terms: (s || DEFAULT_SETTINGS).terms
      } : this.state.hdr
    })).catch(() => this._alive && this.setState({
      settings: {
        ...DEFAULT_SETTINGS
      }
    }));
    listReps().then(r => this._alive && this.setState({
      reps: r || []
    })).catch(() => {});
    if (this.isNew()) {
      this.setState({
        quote: null,
        hdr: {
          ...this.state.hdr,
          validUntil: addDays(30)
        }
      });
      this.searchDealers("");
      if (this.state.presetCustomerId) searchDealers("", 200).then(rows => {
        const hit = (rows || []).find(r => r.id === this.state.presetCustomerId || r.customerNumber === this.state.presetCustomerId);
        if (hit && this._alive) this.pickDealer(hit);
      }).catch(() => {});
    } else this.load();
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._pdfTimer);
    clearTimeout(this._dealerTimer);
    clearTimeout(this._catTimer);
  }
  componentDidUpdate(prev) {
    if ((prev.params && prev.params.id) !== (this.props.params && this.props.params.id) && !this.isNew()) {
      this.setState({
        quote: undefined,
        lines: [],
        dirty: false,
        busy: false,
        notice: null
      });
      this.load();
    }
  }
  load() {
    getQuote(this.id()).then(q => {
      if (!this._alive) return;
      this.setState({
        quote: q,
        lines: q ? q.lines.map(l => ({
          ...l,
          _serverPriced: true
        })) : [],
        hdr: q ? this.hdrFrom(q) : this.state.hdr,
        dirty: false
      });
    }).catch(() => this._alive && this.setState({
      error: true
    }));
  }
  hdrFrom(q) {
    return {
      title: q.title || "",
      repCode: q.repCode || "",
      contact: {
        ...q.contact
      },
      validUntil: q.validUntil || "",
      terms: q.terms || "",
      notes: q.notes || "",
      shipTo: q.shipTo ? {
        ...q.shipTo
      } : null,
      freight: q.freight || {
        mode: "quote",
        amount: null
      }
    };
  }

  // ---- tier --------------------------------------------------------------
  tier() {
    const {
      quote,
      tiers,
      dealer
    } = this.state;
    const code = quote && quote.priceTier || dealer && dealer.priceTier || "";
    if (tiers) {
      const hit = tiers.find(t => t.code === code) || tiers.find(t => t.isDefault) || tiers[0];
      if (hit) return hit;
    }
    // The detail row carries the snapshot (priceTierName, tierDiscountPct) even when the tiers list is unavailable.
    if (quote && (quote.priceTier || quote.priceTierName) && quote.tierDiscountPct != null) return {
      code: quote.priceTier,
      name: quote.priceTierName || quote.priceTier,
      discountPct: quote.tierDiscountPct,
      categoryOverrides: {},
      _snapshot: true
    };
    return null;
  }
  priced() {
    const tier = this.tier();
    return this.state.lines.map(l => priceLine(l, tier));
  }

  // ---- new mode: dealer picker -------------------------------------------------
  searchDealers(term) {
    clearTimeout(this._dealerTimer);
    this._dealerTimer = setTimeout(() => searchDealers(term, 20).then(rows => this._alive && this.setState({
      dealerRows: rows
    })).catch(() => this._alive && this.setState({
      dealerRows: []
    })), 250);
  }
  // ---- lines -----------------------------------------------------------------
  setLine(i, patch) {
    this.setState(s => ({
      lines: s.lines.map((l, j) => j === i ? {
        ...l,
        ...patch,
        _serverPriced: patch.quantity !== undefined || patch.config !== undefined || patch.overridePrice !== undefined ? false : l._serverPriced
      } : l),
      dirty: true,
      lineError: s.lineError && s.lineError.index === i ? null : s.lineError
    }));
  }
  removeLine(i) {
    this.setState(s => ({
      lines: s.lines.filter((l, j) => j !== i),
      dirty: true,
      lineError: null
    }));
  }
  moveLine(i, d) {
    this.setState(s => {
      const a = s.lines.slice();
      const j = i + d;
      if (j < 0 || j >= a.length) return null;
      [a[i], a[j]] = [a[j], a[i]];
      return {
        lines: a,
        dirty: true,
        lineError: null
      };
    });
  }
  searchCatalog(term) {
    clearTimeout(this._catTimer);
    if (!term.trim()) {
      this.setState({
        catRows: null
      });
      return;
    }
    this._catTimer = setTimeout(() => searchCatalog(term, 20).then(rows => this._alive && this.setState({
      catRows: rows
    })).catch(() => this._alive && this.setState({
      catRows: []
    })), 250);
  }
  openConfigure(i) {
    const line = this.state.lines[i];
    this.setState({
      modal: "configure",
      modalIdx: i,
      cfgSets: undefined,
      cfgDraft: {
        ...(line.config || {})
      },
      cfgNote: line.note || ""
    });
    getConfigOptions(line.productId).then(sets => this._alive && this.setState({
      cfgSets: sets
    })).catch(() => this._alive && this.setState({
      cfgSets: null
    }));
  }
  openOverride(i) {
    const l = this.priced()[i];
    this.setState({
      modal: "override",
      modalIdx: i,
      ovPrice: l.overridePrice != null ? String(l.overridePrice) : String(l.netPrice || ""),
      ovReason: l.overrideReason || ""
    });
  }
  clearOverride(i) {
    this.setLine(i, {
      overridePrice: null,
      overrideReason: "",
      overrideBy: ""
    });
  }
  // ---- render -----------------------------------------------------------------------
  hdrField(label, node, help) {
    return /*#__PURE__*/React.createElement("div", {
      className: "fld"
    }, /*#__PURE__*/React.createElement("label", null, label), node, help ? /*#__PURE__*/React.createElement("small", null, help) : null);
  }
  setHdr(patch) {
    this.setState(s => ({
      hdr: {
        ...s.hdr,
        ...patch
      },
      dirty: true
    }));
  }
  renderNew() {
    const {
      dealer,
      dealerRows,
      dealerQ,
      hdr,
      reps,
      busy,
      notice,
      tiers,
      presetCustomerId
    } = this.state;
    const tier = this.tier();
    return /*#__PURE__*/React.createElement(QuotesShell, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Crumb, {
        to: "/Quotes"
      }, "Quotes"), " \xB7 New quote"),
      title: "New quote",
      subtitle: "Pick the dealer, set the contact and validity, then add lines from the catalog on the draft",
      actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
        onClick: () => this.props.history.push("/Quotes")
      }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
        primary: true,
        disabled: busy || !dealer,
        onClick: this.create
      }, busy ? "Creating…" : "Create draft"))
    }, notice ? /*#__PURE__*/React.createElement(Notice, {
      tone: notice.tone,
      onClose: () => this.setState({
        notice: null
      })
    }, notice.text) : null, /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      span: 7,
      title: "Dealer",
      hint: "the quote goes to one dealer account; tier pricing follows the account"
    }, dealer ? /*#__PURE__*/React.createElement("div", {
      className: "qt-dealer-pick"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, dealer.name), dealer.customerNumber ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, " \xB7 ", dealer.customerNumber) : null, /*#__PURE__*/React.createElement("small", null, [[dealer.city, dealer.region].filter(Boolean).join(", "), dealer.customerSince ? `customer since ${fmtDate(dealer.customerSince)}` : null, dealer.assignedRepId ? `rep ${dealer.assignedRepId}` : null].filter(Boolean).join(" · "))), /*#__PURE__*/React.createElement(Btn, {
      small: true,
      onClick: () => this.setState({
        dealer: null,
        dealerRows: null
      })
    }, "Change")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "cust-search wa-search",
      style: {
        width: "100%",
        maxWidth: 420
      },
      type: "search",
      autoFocus: true,
      placeholder: "Search dealers by name or account number",
      value: dealerQ,
      onChange: e => {
        this.setState({
          dealerQ: e.target.value
        });
        this.searchDealers(e.target.value);
      }
    }), dealerRows === null ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Searching\u2026") : dealerRows.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, dealerQ ? "No dealers match." : "No dealer accounts yet. Dealers come from the customer feed or Customers › Add customer.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap",
      style: {
        maxHeight: 360
      }
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Dealer"), /*#__PURE__*/React.createElement("th", null, "Location"), /*#__PURE__*/React.createElement("th", null, "Rep"), /*#__PURE__*/React.createElement("th", null, "Tier"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, dealerRows.map(d => /*#__PURE__*/React.createElement("tr", {
      key: d.id,
      className: "clickable",
      onClick: () => this.pickDealer(d)
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, d.name || d.id), d.customerNumber ? /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, d.customerNumber) : null), /*#__PURE__*/React.createElement("td", null, [d.city, d.region].filter(Boolean).join(", ") || /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "\u2014")), /*#__PURE__*/React.createElement("td", null, d.assignedRepId || /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "\u2014")), /*#__PURE__*/React.createElement("td", null, d.priceTier || /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "default")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink"
    }, "Pick"))))))), presetCustomerId && !dealer ? /*#__PURE__*/React.createElement("p", {
      className: "wa-foot"
    }, "Opened from dealer ", presetCustomerId, "; pick it from the list to confirm.") : null)), /*#__PURE__*/React.createElement(Card, {
      span: 5,
      title: "Header",
      hint: "everything here can change on the draft"
    }, /*#__PURE__*/React.createElement("div", {
      className: "qt-side-fields ec-form"
    }, this.hdrField("Title", /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      value: hdr.title,
      placeholder: "Spring floor refresh",
      onChange: e => this.setHdr({
        title: e.target.value
      })
    })), this.hdrField("Rep", /*#__PURE__*/React.createElement("select", {
      className: "ec-input",
      value: hdr.repCode,
      onChange: e => this.setHdr({
        repCode: e.target.value
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "From the account"), reps.map(r => /*#__PURE__*/React.createElement("option", {
      key: r.repCode,
      value: r.repCode
    }, r.name || r.repCode, " \xB7 ", r.repCode))), dealer && dealer.assignedRepId ? `account's assigned rep: ${dealer.assignedRepId}` : null), this.hdrField("Contact", /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      placeholder: "Name",
      value: hdr.contact.name,
      onChange: e => this.setHdr({
        contact: {
          ...hdr.contact,
          name: e.target.value
        }
      })
    }), /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      placeholder: "Email",
      value: hdr.contact.email,
      onChange: e => this.setHdr({
        contact: {
          ...hdr.contact,
          email: e.target.value
        }
      })
    }), /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      placeholder: "Phone",
      value: hdr.contact.phone,
      onChange: e => this.setHdr({
        contact: {
          ...hdr.contact,
          phone: e.target.value
        }
      })
    }))), this.hdrField("Valid until", /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      type: "date",
      value: hdr.validUntil,
      onChange: e => this.setHdr({
        validUntil: e.target.value
      })
    }), `${(this.state.settings || DEFAULT_SETTINGS).validDays} days from today is the workspace default`), this.hdrField("Price tier", /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, tiers === undefined ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "loading tiers\u2026") : tiers === null ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "tiers not available yet") : tier ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
      tone: "success"
    }, tier.name || tier.code, " \xB7 ", pctFmt(tier.discountPct), " off list"), dealer && !dealer.priceTier ? /*#__PURE__*/React.createElement("small", null, "default tier (the account has none set)") : null) : /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "no tiers defined: set them under Manage Data \u203A Price tiers")))))));
  }
  renderLines(q, lines, locked) {
    const {
      comBusy,
      settings,
      lineError
    } = this.state;
    const admin = isAdminUser();
    const maxOv = (settings || DEFAULT_SETTINGS).maxOverridePct;
    return /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table qt-lines"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      style: {
        width: 44
      }
    }), /*#__PURE__*/React.createElement("th", null, "Item"), /*#__PURE__*/React.createElement("th", {
      className: "n",
      style: {
        width: 70
      }
    }, "Qty"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "List"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Tier"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Net"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Extended"), /*#__PURE__*/React.createElement("th", {
      style: {
        width: 150
      }
    }))), /*#__PURE__*/React.createElement("tbody", null, lines.map((l, i) => {
      const com = isCom(l);
      const beyond = l.overridePrice != null && l.netPrice > 0 ? (l.netPrice - l.overridePrice) / l.netPrice * 100 : 0;
      return /*#__PURE__*/React.createElement("tr", {
        key: l.id || `${l.productId}-${i}`
      }, /*#__PURE__*/React.createElement("td", null, l.imageUrl ? /*#__PURE__*/React.createElement("img", {
        className: "qt-thumb",
        src: l.imageUrl,
        alt: "",
        loading: "lazy",
        onError: e => {
          e.target.style.display = "none";
        }
      }) : /*#__PURE__*/React.createElement("span", {
        className: "qt-thumb qt-thumb-empty"
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "weekend"))), /*#__PURE__*/React.createElement("td", {
        className: "wrap"
      }, /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, l.title || l.productId), /*#__PURE__*/React.createElement("span", {
        className: "qt-cfg"
      }, l.configText || configText(l.config) || /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "no configuration"), l.optionAdders ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 adders ", money(l.optionAdders)) : null, l.sku && l.sku !== l.productId ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 SKU ", l.sku) : /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", l.productId), l.availability && availLabel(l.availability) ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement(Pill, {
        tone: availTone(l.availability)
      }, availLabel(l.availability))) : null, com ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", l.comOrderId ? /*#__PURE__*/React.createElement(Pill, {
        tone: comTone(l.comStatus)
      }, comLabel(l.comStatus)) : /*#__PURE__*/React.createElement(Pill, {
        tone: "warning"
      }, "COM/COL: no request yet")) : null, l.overridePrice != null ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("span", {
        className: "plk-chip accent"
      }, "override ", money(l.overridePrice), " \xB7 ", l.overrideReason, l.overrideBy ? ` · ${l.overrideBy.split("@")[0]}` : ""), beyond > maxOv ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("span", {
        className: "plk-chip warn"
      }, Math.round(beyond), "% below tier \xB7 needs approval")) : null) : null, l.note ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, l.note)) : null, lineError && lineError.index === i ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("span", {
        className: "plk-chip bad"
      }, lineError.text)) : null)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, locked ? l.quantity : /*#__PURE__*/React.createElement("input", {
        className: "qt-qty",
        type: "number",
        min: "1",
        value: l.quantity,
        onChange: e => this.setLine(i, {
          quantity: Math.max(1, parseInt(e.target.value, 10) || 1)
        })
      })), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, money(l.listPrice), l.optionAdders ? /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, " +", Math.round(l.optionAdders)) : null), /*#__PURE__*/React.createElement("td", {
        className: "n",
        title: l.discountRule || ""
      }, l.overridePrice != null ? /*#__PURE__*/React.createElement("span", {
        className: "qt-strike"
      }, pctFmt(l.discountPct)) : pctFmt(l.discountPct), /*#__PURE__*/React.createElement("span", {
        className: "code"
      }, l.discountRule || "tier")), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, money(l.unit != null ? l.unit : l.netPrice)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, /*#__PURE__*/React.createElement("b", null, money(l.extended))), /*#__PURE__*/React.createElement("td", null, locked ? null : /*#__PURE__*/React.createElement("span", {
        className: "qt-acts"
      }, /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink",
        onClick: () => this.openConfigure(i)
      }, "Configure"), com && !l.comOrderId ? /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink",
        onClick: () => this.comRequest(i)
      }, comBusy === l.id ? "Creating…" : "Create COM request") : null, com && l.comOrderId ? /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink",
        title: `Studio COM request ${l.comOrderId}`,
        onClick: () => this.comRequest(i)
      }, "Open COM request") : null, l.overridePrice != null ? /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink muted",
        onClick: () => this.clearOverride(i)
      }, "Clear override") : /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink",
        onClick: () => this.openOverride(i)
      }, "Override"), /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink muted",
        onClick: () => this.removeLine(i)
      }, "Remove"), /*#__PURE__*/React.createElement("span", {
        className: "qt-move"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: i === 0,
        onClick: () => this.moveLine(i, -1),
        title: "Move up"
      }, "\u2191"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: i === lines.length - 1,
        onClick: () => this.moveLine(i, 1),
        title: "Move down"
      }, "\u2193")))));
    }))));
  }
  renderModals(q, lines) {
    const {
      modal,
      modalIdx,
      catQ,
      catRows,
      cfgSets,
      cfgDraft,
      cfgNote,
      ovPrice,
      ovReason,
      busy,
      sendTo,
      sendCc,
      sendMsg,
      sendValid,
      sendErr,
      sentLink,
      poNumber,
      requestedDate,
      voidReason,
      extendDate,
      tierPick,
      tiers,
      settings
    } = this.state;
    const close = () => this.setState({
      modal: null,
      modalIdx: -1
    });
    const st = settings || DEFAULT_SETTINGS;
    if (modal === "catalog") {
      return /*#__PURE__*/React.createElement(Modal, {
        title: "Add from catalog",
        width: 720,
        onClose: close,
        footer: /*#__PURE__*/React.createElement(Btn, {
          onClick: close
        }, "Close"),
        note: "search by SKU, title or family; list price is sale price when set, else price"
      }, /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        autoFocus: true,
        placeholder: "Search SKU, title, family",
        value: catQ,
        onChange: e => {
          this.setState({
            catQ: e.target.value
          });
          this.searchCatalog(e.target.value);
        }
      }), catRows === null ? catQ.trim() ? /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, "Searching\u2026") : /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, "Type to search the catalog.") : catRows.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, "No products match.") : /*#__PURE__*/React.createElement("div", {
        className: "tblwrap",
        style: {
          maxHeight: 380,
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null, "Product"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "List"), /*#__PURE__*/React.createElement("th", null, "Availability"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, catRows.map(p => /*#__PURE__*/React.createElement("tr", {
        key: p.productId,
        className: "clickable",
        onClick: () => this.addFromCatalog(p)
      }, /*#__PURE__*/React.createElement("td", null, p.imageUrl ? /*#__PURE__*/React.createElement("img", {
        className: "qt-thumb",
        src: p.imageUrl,
        alt: "",
        loading: "lazy",
        onError: e => {
          e.target.style.display = "none";
        }
      }) : null), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "name"
      }, p.title || p.productId), /*#__PURE__*/React.createElement("span", {
        className: "code"
      }, p.sku || p.productId, p.category ? ` · ${String(p.category).split(/\s*[>/]\s*/).pop()}` : "")), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, money(p.listPrice)), /*#__PURE__*/React.createElement("td", null, p.availability ? /*#__PURE__*/React.createElement(Pill, {
        tone: availTone(p.availability)
      }, p.availability) : /*#__PURE__*/React.createElement("span", {
        className: "dim"
      }, "\u2014")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        className: "wa-rowlink"
      }, "Add"))))))));
    }
    if (modal === "configure" && lines[modalIdx]) {
      const line = lines[modalIdx];
      const chosenAdders = (cfgSets || []).reduce((a, set) => {
        const o = (set.options || []).find(x => x.value === cfgDraft[set.name] || x.label === cfgDraft[set.name]);
        return a + (o ? Number(o.adder) || 0 : 0);
      }, 0);
      const comPicked = Object.entries(cfgDraft).some(([k, v]) => /cover|fabric|material/i.test(k) && COM_RE.test(String(v)));
      const freeKeys = Object.keys(cfgDraft).filter(k => !(cfgSets || []).some(s => s.name === k));
      return /*#__PURE__*/React.createElement(Modal, {
        title: `Configure · ${line.title || line.productId}`,
        width: 620,
        onClose: close,
        busy: busy,
        footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
          onClick: close
        }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
          primary: true,
          onClick: this.applyConfigure
        }, "Apply")),
        note: cfgSets ? "options from the configuration rail; the catalog validates and resolves the SKU and adders on save" : undefined
      }, cfgSets === undefined ? /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, "Loading options\u2026") : cfgSets === null || cfgSets.length === 0 ? /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, cfgSets === null ? "Configuration options are not available yet for this product. " : "This product has no option sets in the catalog. ", "Note the configuration as text below; it prints on the quote as written.") : cfgSets.map(set => /*#__PURE__*/React.createElement("div", {
        className: "ec-field",
        key: set.name
      }, /*#__PURE__*/React.createElement("label", null, set.name, set.required ? " *" : ""), /*#__PURE__*/React.createElement("select", {
        className: "ec-input",
        value: cfgDraft[set.name] || "",
        onChange: e => this.setState({
          cfgDraft: {
            ...cfgDraft,
            [set.name]: e.target.value
          }
        })
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "none"), set.options.map(o => /*#__PURE__*/React.createElement("option", {
        key: o.value,
        value: o.value
      }, o.label, o.adder ? ` · +${money0(o.adder)}` : ""))))), /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Free-text configuration (name: value per line)"), /*#__PURE__*/React.createElement("textarea", {
        className: "ec-input",
        rows: 3,
        placeholder: "Cover: Hemp Natural\nFinish: Driftwood",
        value: freeKeys.map(k => `${k}: ${cfgDraft[k]}`).join("\n"),
        onChange: e => {
          const next = {};
          (cfgSets || []).forEach(s => {
            if (cfgDraft[s.name]) next[s.name] = cfgDraft[s.name];
          });
          e.target.value.split("\n").forEach(row => {
            const m = /^\s*([^:]+):\s*(.*)$/.exec(row);
            if (m) next[m[1].trim()] = m[2].trim();
          });
          this.setState({
            cfgDraft: next
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Fabric or line note"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        value: cfgNote,
        placeholder: "COM yardage, swatch, special instructions",
        onChange: e => this.setState({
          cfgNote: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "qt-cfg-foot"
      }, chosenAdders ? /*#__PURE__*/React.createElement(Pill, {
        tone: "info"
      }, "adders ", money(chosenAdders)) : null, comPicked ? /*#__PURE__*/React.createElement("span", {
        className: "ec-help"
      }, "Cover reads COM/COL: after Apply and Save, use Create COM request on the line to open the Studio request. Nothing is created until that click.") : null));
    }
    if (modal === "override" && lines[modalIdx]) {
      const l = lines[modalIdx];
      const beyond = l.netPrice > 0 && Number(ovPrice) ? (l.netPrice - Number(ovPrice)) / l.netPrice * 100 : 0;
      return /*#__PURE__*/React.createElement(Modal, {
        title: `Override price · ${l.title || l.productId}`,
        width: 480,
        onClose: close,
        footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
          onClick: close
        }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
          primary: true,
          disabled: !ovReason.trim() || !Number(ovPrice),
          onClick: this.applyOverride
        }, "Apply override")),
        note: `tier net ${money(l.netPrice)} · sales users may go up to ${st.maxOverridePct}% below tier without approval`
      }, /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Unit price"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input ec-num wide",
        type: "number",
        step: "0.01",
        min: "0",
        value: ovPrice,
        onChange: e => this.setState({
          ovPrice: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Reason (required)"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        autoFocus: true,
        value: ovReason,
        placeholder: "floor sample, volume commitment, price match",
        onChange: e => this.setState({
          ovReason: e.target.value
        })
      })), beyond > st.maxOverridePct && !isAdminUser() ? /*#__PURE__*/React.createElement("p", {
        className: "ec-help",
        style: {
          color: "var(--plk-warning-text)"
        }
      }, Math.round(beyond), "% below tier is beyond the limit: the quote will wait for an administrator's approval before it can be sent.") : null);
    }
    if (modal === "send") {
      const link = sentLink;
      return /*#__PURE__*/React.createElement(Modal, {
        title: `Send ${q.number || "quote"} v${q.status === "draft" ? q.version : q.version + 1}`,
        width: 560,
        onClose: close,
        busy: busy,
        footer: link ? /*#__PURE__*/React.createElement(Btn, {
          primary: true,
          onClick: close
        }, "Done") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
          disabled: busy,
          onClick: close
        }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
          primary: true,
          disabled: busy,
          onClick: this.send
        }, busy ? "Sending…" : "Send")),
        note: link ? undefined : "one email on the notification rail, a PDF, and the branded acceptance link; replies reach you"
      }, link ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, "Sent. The dealer accepts on this link; copy it for a call or a text."), /*#__PURE__*/React.createElement("div", {
        className: "qt-linkrow"
      }, /*#__PURE__*/React.createElement("code", null, link), /*#__PURE__*/React.createElement(Btn, {
        small: true,
        onClick: this.copyLink
      }, this.state.copied ? "Copied" : "Copy link"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "To"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        value: sendTo,
        placeholder: "dealer contact email",
        onChange: e => this.setState({
          sendTo: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Cc"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        value: sendCc,
        placeholder: "comma-separated, optional",
        onChange: e => this.setState({
          sendCc: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Valid until"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        type: "date",
        value: sendValid,
        onChange: e => this.setState({
          sendValid: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Message"), /*#__PURE__*/React.createElement("textarea", {
        className: "ec-input",
        rows: 3,
        value: sendMsg,
        placeholder: "A line or two for the dealer",
        onChange: e => this.setState({
          sendMsg: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "ec-checks"
      }, /*#__PURE__*/React.createElement("label", {
        className: "ec-check"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: true,
        readOnly: true
      }), /*#__PURE__*/React.createElement("span", null, "Attach the PDF")), /*#__PURE__*/React.createElement("label", {
        className: "ec-check"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: !!st.showListPrices,
        readOnly: true
      }), /*#__PURE__*/React.createElement("span", null, "Show list prices and the discount on the page (workspace setting)")), /*#__PURE__*/React.createElement("label", {
        className: "ec-check"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: !!st.requireContactEmail,
        readOnly: true
      }), /*#__PURE__*/React.createElement("span", null, "Require the dealer's email to match the contact (workspace setting)"))), sendErr ? /*#__PURE__*/React.createElement("p", {
        className: "ec-err"
      }, sendErr) : null, q.status !== "draft" ? /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, "This quote was already sent: sending again makes v", q.version + 1, " on the same link and the dealer gets a \"quote updated\" email.") : null));
    }
    if (modal === "convert") {
      return /*#__PURE__*/React.createElement(Modal, {
        title: "Convert to order request",
        width: 480,
        onClose: close,
        busy: busy,
        footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
          disabled: busy,
          onClick: close
        }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
          primary: true,
          disabled: busy,
          onClick: this.convert
        }, busy ? "Converting…" : "Create order request")),
        note: "for an acceptance taken on the phone or at the desk; the dealer's link acceptance does this on its own"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Dealer PO number"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        autoFocus: true,
        value: poNumber,
        onChange: e => this.setState({
          poNumber: e.target.value
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Requested ship date (optional)"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        type: "date",
        value: requestedDate,
        onChange: e => this.setState({
          requestedDate: e.target.value
        })
      })), /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, "The lines are snapshotted as accepted, the quote becomes Converted, and the request waits for the ERP under Orders."));
    }
    if (modal === "extend") {
      return /*#__PURE__*/React.createElement(Modal, {
        title: "Extend validity",
        width: 420,
        onClose: close,
        busy: busy,
        footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
          onClick: close
        }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
          primary: true,
          disabled: !extendDate || busy,
          onClick: this.extend
        }, "Extend and resend"))
      }, /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "New valid-until date"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        type: "date",
        autoFocus: true,
        value: extendDate,
        onChange: e => this.setState({
          extendDate: e.target.value
        })
      })));
    }
    if (modal === "void") {
      return /*#__PURE__*/React.createElement(Modal, {
        title: `Void ${q.number || "quote"}`,
        width: 440,
        onClose: close,
        busy: busy,
        footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
          onClick: close
        }, "Keep"), /*#__PURE__*/React.createElement(Btn, {
          danger: true,
          disabled: !voidReason.trim() || busy,
          onClick: this.doVoid
        }, "Void quote"))
      }, /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Reason"), /*#__PURE__*/React.createElement("input", {
        className: "ec-input",
        autoFocus: true,
        value: voidReason,
        onChange: e => this.setState({
          voidReason: e.target.value
        })
      })), /*#__PURE__*/React.createElement("p", {
        className: "ec-help"
      }, "A void quote stays in the list for the record; the dealer's link stops working."));
    }
    if (modal === "tier") {
      return /*#__PURE__*/React.createElement(Modal, {
        title: "Switch tier for this quote",
        width: 440,
        onClose: close,
        busy: busy,
        footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
          onClick: close
        }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
          primary: true,
          disabled: !tierPick || busy,
          onClick: this.switchTier
        }, "Switch")),
        note: "administrators only; audited; the dealer's account tier does not change"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ec-field"
      }, /*#__PURE__*/React.createElement("label", null, "Tier"), /*#__PURE__*/React.createElement("select", {
        className: "ec-input",
        value: tierPick,
        onChange: e => this.setState({
          tierPick: e.target.value
        })
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "choose"), (tiers || []).map(t => /*#__PURE__*/React.createElement("option", {
        key: t.code,
        value: t.code
      }, t.name || t.code, " \xB7 ", pctFmt(t.discountPct), " off")))));
    }
    return null;
  }
  render() {
    const {
      quote,
      error,
      notice,
      busy,
      dirty,
      hdr,
      reps,
      tiers,
      pdfBusy,
      copied
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (this.isNew()) return /*#__PURE__*/React.createElement(QuotesGate, null, this.renderNew());
    if (quote === undefined) return /*#__PURE__*/React.createElement(QuotesGate, null, /*#__PURE__*/React.createElement(Loader, null));
    if (quote === null) {
      return /*#__PURE__*/React.createElement(QuotesGate, null, /*#__PURE__*/React.createElement(QuotesShell, {
        crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Crumb, {
          to: "/Quotes"
        }, "Quotes"), " \xB7 Quote"),
        title: `Quote ${this.id()}`
      }, /*#__PURE__*/React.createElement("div", {
        className: "wa-grid"
      }, /*#__PURE__*/React.createElement(Card, {
        title: "Quote"
      }, /*#__PURE__*/React.createElement("p", {
        className: "territory-hint",
        style: {
          margin: 0
        }
      }, "This quote is not available yet. The desk's backend is being enabled; the list shows every quote once the rail answers.")))));
    }
    const q = quote;
    const locked = isLocked(q);
    const admin = isAdminUser();
    const lines = this.priced();
    const totals = dirty || !q.subtotalNet ? totalsOf(lines) : {
      subtotalList: q.subtotalList,
      discountTotal: q.discountTotal,
      subtotalNet: q.subtotalNet,
      units: lines.reduce((a, l) => a + (Number(l.quantity) || 0), 0)
    };
    const tier = this.tier();
    const tierPct = tier ? tierPctFor(tier, "") : null;
    const comPending = lines.filter(l => isCom(l) && (!l.comOrderId || String(l.comStatus).toLowerCase() === "draft")).length;
    const overrides = lines.filter(l => l.overridePrice != null).length;
    const link = q.link || acceptanceLink(q);
    const left = daysUntil(hdr.validUntil || q.validUntil);
    const rep = reps.find(r => r.repCode === (hdr.repCode || q.repCode));
    const canSend = !locked && q.status !== "pending_approval";
    const activity = (q.activity || []).slice().reverse();
    const actions = /*#__PURE__*/React.createElement(React.Fragment, null, !locked ? /*#__PURE__*/React.createElement(Btn, {
      disabled: busy || pdfBusy,
      onClick: this.previewPdf
    }, pdfBusy ? "Rendering…" : "Preview PDF") : q.pdfUrl ? /*#__PURE__*/React.createElement("a", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base",
      href: q.pdfUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "PDF") : null, /*#__PURE__*/React.createElement(Btn, {
      disabled: busy,
      onClick: this.duplicate
    }, "Duplicate"), q.status === "pending_approval" && admin ? /*#__PURE__*/React.createElement(Btn, {
      primary: true,
      disabled: busy,
      onClick: this.approve
    }, "Approve") : null, ["sent", "viewed", "expired"].includes(q.status) ? /*#__PURE__*/React.createElement(Btn, {
      disabled: busy,
      onClick: () => this.setState({
        modal: "extend",
        extendDate: addDays((this.state.settings || DEFAULT_SETTINGS).validDays)
      })
    }, "Extend") : null, ["sent", "viewed"].includes(q.status) && !q.orderRequestId ? /*#__PURE__*/React.createElement(Btn, {
      disabled: busy,
      onClick: () => this.setState({
        modal: "convert",
        poNumber: "",
        requestedDate: ""
      })
    }, "Convert to order request") : null, q.orderRequestId ? /*#__PURE__*/React.createElement(Btn, {
      onClick: () => this.props.history.push(`/Quotes/orders/${encodeURIComponent(q.orderRequestId)}`)
    }, "Order request", q.orderRequestNumber ? ` ${q.orderRequestNumber}` : "") : null, canSend ? /*#__PURE__*/React.createElement(Btn, {
      primary: true,
      disabled: busy || lines.length === 0,
      title: comPending ? "A COM/COL line still needs its fabric; the send will be refused until the request has a yardage quote" : undefined,
      onClick: this.openSend
    }, q.status === "draft" ? "Send to dealer" : "Resend as new version") : null);
    return /*#__PURE__*/React.createElement(QuotesGate, null, /*#__PURE__*/React.createElement(QuotesShell, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Crumb, {
        to: "/Quotes"
      }, "Quotes"), " \xB7 Quote"),
      title: q.number || `Quote ${q.id}`,
      subtitle: [q.customerName ? `${q.customerName}${q.customerNumber ? ` (${q.customerNumber})` : ""}` : null, rep ? `Rep ${rep.name || rep.repCode}` : q.repCode ? `Rep ${q.repCode}` : null, tier ? `Tier ${tier.name || tier.code} (${pctFmt(tier.discountPct)} off)` : null, q.modifiedDate ? `saved ${relTime(q.modifiedDate)}` : null].filter(Boolean).join(" · "),
      chips: [{
        k: "Version",
        v: `v${q.version}`
      }, {
        k: "Status",
        v: /*#__PURE__*/React.createElement(QuoteStatus, {
          q: q
        })
      }],
      actions: actions
    }, notice ? /*#__PURE__*/React.createElement(Notice, {
      tone: notice.tone,
      onClose: () => this.setState({
        notice: null
      })
    }, notice.text) : null, locked ? /*#__PURE__*/React.createElement(Notice, {
      tone: "info"
    }, "This quote is ", normStatus(q.status) === "converted" ? "accepted and converted" : q.status, normStatus(q.status) === "converted" && q.orderRequestNumber ? ` into ${q.orderRequestNumber}` : "", q.status === "declined" && q.declinedReason ? `: "${q.declinedReason}"` : "", ". It is read-only; duplicate it to quote again.") : null, q.status === "pending_approval" && !admin ? /*#__PURE__*/React.createElement(Notice, {
      tone: "warning"
    }, "An override on this quote is beyond the tier's limit. An administrator approves it before it can be sent.") : null, /*#__PURE__*/React.createElement("div", {
      className: "qt-editor"
    }, /*#__PURE__*/React.createElement("div", {
      className: "qt-main"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Lines",
      hint: `${lines.length} line${lines.length === 1 ? "" : "s"} · ${totals.units} unit${totals.units === 1 ? "" : "s"}`,
      right: locked ? null : /*#__PURE__*/React.createElement("span", {
        className: "qt-toolbtns"
      }, /*#__PURE__*/React.createElement(Btn, {
        small: true,
        onClick: () => this.setState({
          modal: "catalog",
          catQ: "",
          catRows: null
        })
      }, "+ Add from catalog"))
    }, lines.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, "No lines yet. Add from catalog: search by SKU, title or family, then configure each line with the product's own options.") : this.renderLines(q, lines, locked), /*#__PURE__*/React.createElement("div", {
      className: "qt-totals"
    }, /*#__PURE__*/React.createElement("span", null, "Subtotal (list)"), /*#__PURE__*/React.createElement("span", null, money(totals.subtotalList)), /*#__PURE__*/React.createElement("span", null, tier ? `Tier discount · ${tier.name || tier.code} ${pctFmt(tier.discountPct)}` : "Discount"), /*#__PURE__*/React.createElement("span", {
      className: "qt-neg"
    }, totals.discountTotal ? `-${money(totals.discountTotal)}` : money(0)), /*#__PURE__*/React.createElement("span", null, "Freight"), /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, hdr.freight && hdr.freight.mode === "flat" && hdr.freight.amount != null ? money(hdr.freight.amount) : hdr.freight && hdr.freight.mode === "tbd" ? "to be determined" : "quoted separately"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "Net total")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, money(totals.subtotalNet)))), /*#__PURE__*/React.createElement("div", {
      className: "qt-foot"
    }, comPending ? /*#__PURE__*/React.createElement("span", {
      className: "plk-chip warn"
    }, comPending, " line", comPending === 1 ? "" : "s", " need", comPending === 1 ? "s" : "", " a COM request before send") : null, overrides ? /*#__PURE__*/React.createElement("span", {
      className: "plk-chip"
    }, overrides, " override", overrides === 1 ? "" : "s") : null, dirty ? /*#__PURE__*/React.createElement("span", {
      className: "plk-chip accent"
    }, "unsaved changes") : null, /*#__PURE__*/React.createElement("span", {
      className: "sp"
    }), !locked ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Btn, {
      flat: true,
      small: true,
      disabled: busy,
      onClick: () => this.setState({
        modal: "void",
        voidReason: ""
      })
    }, "Void"), /*#__PURE__*/React.createElement(Btn, {
      small: true,
      primary: dirty,
      disabled: busy || !dirty,
      onClick: () => this.save()
    }, busy ? "Saving…" : "Save draft")) : null))), /*#__PURE__*/React.createElement("aside", {
      className: "qt-side ec-form"
    }, this.hdrField("Dealer", /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, /*#__PURE__*/React.createElement("b", null, q.customerName || q.customerId), q.customerNumber ? ` · ${q.customerNumber}` : "", /*#__PURE__*/React.createElement("small", null, [[q.customerCity, q.customerRegion].filter(Boolean).join(", ")].filter(Boolean).join(" · ") || "account on file", " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: `/Quotes?customerId=${encodeURIComponent(q.customerId)}&customer=${encodeURIComponent(q.customerName || "")}`
    }, "other quotes")))), this.hdrField("Price tier", /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, tiers === undefined ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "loading tiers\u2026") : tiers === null ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "tiers not available yet") : tier ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
      tone: "success"
    }, tier.name || tier.code, " \xB7 ", pctFmt(tier.discountPct), " off list"), /*#__PURE__*/React.createElement("small", null, tier._snapshot ? "snapshot on the quote" : Object.keys(tier.categoryOverrides || {}).length ? Object.entries(tier.categoryOverrides).map(([k, v]) => `${k} ${pctFmt(v)}`).join(" · ") + " (category overrides)" : "no category overrides", admin && !locked && tiers ? /*#__PURE__*/React.createElement(React.Fragment, null, " \xB7 ", /*#__PURE__*/React.createElement("a", {
      onClick: () => this.setState({
        modal: "tier",
        tierPick: tier.code
      })
    }, "switch for this quote")) : null)) : /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "no tiers defined"))), this.hdrField("Rep", locked ? /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, rep ? `${rep.name} · ${rep.repCode}` : q.repCode || "—") : /*#__PURE__*/React.createElement("select", {
      className: "ec-input",
      value: hdr.repCode,
      onChange: e => this.setHdr({
        repCode: e.target.value
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "From the account"), reps.map(r => /*#__PURE__*/React.createElement("option", {
      key: r.repCode,
      value: r.repCode
    }, r.name || r.repCode, " \xB7 ", r.repCode))), "from the account's assigned rep unless changed"), this.hdrField("Contact", locked ? /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, hdr.contact.name || "—", /*#__PURE__*/React.createElement("small", null, [hdr.contact.email, hdr.contact.phone].filter(Boolean).join(" · "))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      placeholder: "Name",
      value: hdr.contact.name,
      onChange: e => this.setHdr({
        contact: {
          ...hdr.contact,
          name: e.target.value
        }
      })
    }), /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      placeholder: "Email",
      value: hdr.contact.email,
      onChange: e => this.setHdr({
        contact: {
          ...hdr.contact,
          email: e.target.value
        }
      })
    }), /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      placeholder: "Phone",
      value: hdr.contact.phone,
      onChange: e => this.setHdr({
        contact: {
          ...hdr.contact,
          phone: e.target.value
        }
      })
    }))), this.hdrField("Valid until", locked ? /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, fmtDate(q.validUntil) || "—") : /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      type: "date",
      value: hdr.validUntil,
      onChange: e => this.setHdr({
        validUntil: e.target.value
      })
    }), left != null ? left < 0 ? `expired ${-left} day${left === -1 ? "" : "s"} ago` : left === 0 ? "expires today" : `${left} day${left === 1 ? "" : "s"} left` : `${(this.state.settings || DEFAULT_SETTINGS).validDays} days from send is the workspace default`), this.hdrField("Ship to", locked ? /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, hdr.shipTo ? [hdr.shipTo.name, hdr.shipTo.address, [hdr.shipTo.city, hdr.shipTo.region, hdr.shipTo.postal].filter(Boolean).join(" ")].filter(Boolean).join(", ") : "from the account") : /*#__PURE__*/React.createElement("textarea", {
      className: "ec-input",
      rows: 2,
      placeholder: "Name, street, city, state, postal (from the account when blank)",
      value: hdr.shipTo ? [hdr.shipTo.name, hdr.shipTo.address, [hdr.shipTo.city, hdr.shipTo.region, hdr.shipTo.postal].filter(Boolean).join(" ")].filter(Boolean).join(", ") : "",
      onChange: e => this.setHdr({
        shipTo: e.target.value.trim() ? {
          ...(hdr.shipTo || {}),
          text: e.target.value,
          name: hdr.shipTo && hdr.shipTo.name,
          address: e.target.value
        } : null
      })
    }), "from the account; edit for this quote"), this.hdrField("Terms", locked ? /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, hdr.terms || "—") : /*#__PURE__*/React.createElement("input", {
      className: "ec-input",
      placeholder: "Net 30 \xB7 freight quoted separately",
      value: hdr.terms,
      onChange: e => this.setHdr({
        terms: e.target.value
      })
    })), this.hdrField("Freight", locked ? /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, hdr.freight.mode === "flat" ? money(hdr.freight.amount) : hdr.freight.mode === "tbd" ? "to be determined" : "quoted separately") : /*#__PURE__*/React.createElement("div", {
      className: "ec-inline"
    }, /*#__PURE__*/React.createElement("select", {
      className: "ec-input",
      value: hdr.freight.mode,
      onChange: e => this.setHdr({
        freight: {
          ...hdr.freight,
          mode: e.target.value
        }
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: "quote"
    }, "quoted separately"), /*#__PURE__*/React.createElement("option", {
      value: "flat"
    }, "flat amount"), /*#__PURE__*/React.createElement("option", {
      value: "tbd"
    }, "to be determined")), hdr.freight.mode === "flat" ? /*#__PURE__*/React.createElement("input", {
      className: "ec-input ec-num wide",
      type: "number",
      step: "0.01",
      value: hdr.freight.amount != null ? hdr.freight.amount : "",
      onChange: e => this.setHdr({
        freight: {
          ...hdr.freight,
          amount: e.target.value === "" ? null : Number(e.target.value)
        }
      })
    }) : null)), this.hdrField("Notes to dealer", locked ? /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, hdr.notes || "—") : /*#__PURE__*/React.createElement("textarea", {
      className: "ec-input",
      rows: 3,
      value: hdr.notes,
      onChange: e => this.setHdr({
        notes: e.target.value
      })
    })), link ? this.hdrField("Acceptance link", /*#__PURE__*/React.createElement("div", {
      className: "v qt-linkrow"
    }, /*#__PURE__*/React.createElement("code", null, link), /*#__PURE__*/React.createElement(Btn, {
      small: true,
      onClick: this.copyLink
    }, copied ? "Copied" : "Copy")), q.viewedDate ? `viewed ${fmtDateTime(q.viewedDate)}` : q.sentDate ? `sent ${fmtDateTime(q.sentDate)}, not opened yet` : null) : null, q.pdfUrl ? this.hdrField("PDF", /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, /*#__PURE__*/React.createElement("a", {
      href: q.pdfUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Open the PDF"), /*#__PURE__*/React.createElement("small", null, "v", q.version))) : null, q.accepted ? this.hdrField("Accepted", /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, q.accepted.name || "—", q.accepted.po ? ` · PO ${q.accepted.po}` : "", /*#__PURE__*/React.createElement("small", null, [q.accepted.email, q.acceptedDate ? fmtDateTime(q.acceptedDate) : null, q.accepted.note].filter(Boolean).join(" · ")))) : null, this.hdrField("Activity", /*#__PURE__*/React.createElement("div", {
      className: "v qt-activity"
    }, activity.length === 0 ? /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, q.createdDate ? `Created ${fmtDate(q.createdDate)}${q.owner ? ` · ${q.owner.split("@")[0]}` : ""}` : "no activity yet") : activity.slice(0, 8).map((a, i) => /*#__PURE__*/React.createElement("span", {
      key: i
    }, [a.date ? fmtDateTime(a.date) : null, String(a.action || "").replace(/^quote\./, "").replace(/_/g, " "), a.actor ? String(a.actor).split("@")[0] : null, a.note].filter(Boolean).join(" · "))))))), this.renderModals(q, lines)));
  }
}
export default withRouter(QuoteEditorView);